import React, { Component } from 'react'
import union from '@turf/union'
import bbox from 'geojson-bbox'
import GoogleMap from 'common/views/components/GoogleMap'

function reduceIfGeometryCollection(geoJsonData) {
  if (geoJsonData.type === 'GeometryCollection') {
    const geometries = _.filter(geoJsonData.geometries, g => {
      return !_.includes(['MultiPoint', 'Point', 'LineString'], g.type)
    })
    const combinedGeometries = geometries.reduce(union)
    return combinedGeometries.type === 'Feature' ? combinedGeometries.geometry : combinedGeometries
  }
  return geoJsonData
}

function processGeoJsonData(geoJsonData) {
  let geoJson

  if (_.isArray(geoJsonData)) {
    if (geoJsonData.length > 1) {
      let reducedGeoJson = geoJsonData.reduce((a, b) => {
        a = reduceIfGeometryCollection(a)
        b = reduceIfGeometryCollection(b)

        return union(a, b)
      })
      geoJson = reducedGeoJson.geometry
    } else {
      geoJson = reduceIfGeometryCollection(geoJsonData[0])
    }
  } else if (_.isPlainObject(geoJsonData)) {
    geoJson = reduceIfGeometryCollection(geoJsonData)
  } else {
    geoJson = geoJsonData
  }

  return geoJson
}

function getNormalizedBoundsFromGeoJson(geoJsonData) {
  const bounds = bbox(geoJsonData)
  return [
    [bounds[1], bounds[0]],
    [bounds[3], bounds[2]]
  ]
}

export default class SimplifyingGoogleMapComponent extends Component {

  shouldComponentUpdate(nextProps) {
    return nextProps.geoJsonData !== this.props.geoJsonData
  }

  render() {
    const { dispatch } = this.props

    let processedGeoJsonData
    let bounds
    if (this.props.geoJsonData && !_.isEmpty(this.props.geoJsonData)) {
      processedGeoJsonData = processGeoJsonData(this.props.geoJsonData)
      bounds = getNormalizedBoundsFromGeoJson(processedGeoJsonData)
    }
    return (
       <GoogleMap bounds={bounds} geoJsonData={processedGeoJsonData} dispatch={dispatch}/>
    )
  }
}
